import { memo, useEffect, useRef } from 'react';
import Box from '@mui/material/Box';
import { Navigation } from './Navigation';
import { useElementSize } from './common/useTreeHooks';
import { fitEdges } from '../../../utils/treeGraph';
import type { TreeBounds } from '../../../utils/treeGraph';

export const TreeWrapper = memo(
  ({
    zoomIn,
    zoomOut,
    resetTransform,
    setTransform,
    resetRootId,
    resetRootHandler,
    openSearchModal,
    handleDownload,
    handleGedcomExport,
    treeBounds,
    treeKey,
    children,
  }: any) => {
    const wrapperRef = useRef(null);

    const { width: drawingWidth, height: drawingHeight } = useElementSize(
      wrapperRef as any,
    );

    useEffect(() => {
      fitEdges({
        drawingWidth,
        drawingHeight,
        bounds: treeBounds as TreeBounds,
        setTransform,
      });
    }, [drawingWidth, drawingHeight, setTransform, treeBounds, treeKey]);

    return (
      <Box
        sx={{
          position: 'relative',
          flex: 1,
          width: '100%',
          height: '100%',
          minHeight: 0,
          overflow: 'hidden',
        }}
        ref={wrapperRef}
      >
        <Box
          sx={{
            position: 'absolute',
            inset: 0,
            overflow: 'hidden',
            '.react-transform-wrapper, .react-transform-component': {
              width: '100%',
              height: '100%',
            },
          }}
        >
          {children}
        </Box>
        <Navigation
          zoomIn={zoomIn}
          zoomOut={zoomOut}
          resetTransform={resetTransform}
          setTransform={setTransform}
          drawingWidth={drawingWidth}
          drawingHeight={drawingHeight}
          resetRootId={resetRootId}
          resetRootHandler={resetRootHandler}
          openSearchModal={openSearchModal}
          handleDownload={handleDownload}
          handleGedcomExport={handleGedcomExport}
          treeBounds={treeBounds}
        />
      </Box>
    );
  },
);
